import { motion } from 'framer-motion';

export default function RateCard() {
  const now = new Date();
  
  // Format date as "Month Day, Year"
  const currentDate = now.toLocaleDateString('en-US', { 
    month: 'long', 
    day: 'numeric', 
    year: 'numeric' 
  });
  
  // Format time as "h:mm AM/PM"
  const currentTime = now.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit', 
    hour12: true 
  });

  return (
    <section id="rates" className="relative -mt-20 z-10">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-2xl p-8 md:p-12"
        >
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-line-chart-line text-xl text-teal"></i>
                </div>
                <span className="text-xs uppercase tracking-wider text-teal font-semibold">
                  Today's Average Rates
                </span>
              </div>
              
              <div className="mb-3">
                <span className="text-8xl font-bold text-navy">6.875</span>
                <span className="text-5xl font-bold text-navy">%</span>
              </div>
              
              <p className="text-xl text-gray-600 font-medium">30-Year Fixed Mortgage</p>
            </div>
            
            <div className="flex-1 bg-blue-50/50 rounded-2xl p-6 border border-blue-100">
              <div className="flex gap-3 mb-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-information-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-700 leading-relaxed mb-3">
                    <strong className="text-gray-900">Important:</strong> This rate represents a national average and is provided for informational purposes only.
                  </p>
                  <p className="text-sm text-gray-700 leading-relaxed italic">
                    Your actual rate will vary based on your individual circumstances including credit score, down payment amount, property type, loan amount, and current market conditions.
                  </p>
                </div>
              </div>
              
              <div className="pt-4 border-t border-blue-200">
                <p className="text-xs text-gray-500 text-right">
                  Updated: {currentDate} at {currentTime} EST
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}